import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Response} from '../models/models';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartnergroupService {

  constructor(private httpClient: HttpClient) { }

  getPartnerGroups(): Observable<Response<string[]>> {
    return this.httpClient.get<Response<string[]>>(environment.apiPath + 'PartnerGroup');
  }
}
